import { connect } from 'react-redux';
import { productSummaryRequested } from 'state/productSummaryDescription/productSummaryDescription.action';
import type { ShareButtonColor } from 'state/quotes/utils';
import { isPendingEnrichment, isProductSummaryOpened } from 'state/selectors';
import type { ThunkDispatch } from 'state/state.common';
import type { AppState } from 'state/state.model';

interface OwnProps {
  className?: string;
  tabId: string;
  color?: ShareButtonColor;
}
interface StateProps {
  isDisabled: boolean;
}

interface DispatchProps {
  onShare: () => void;
}

export type ShareButtonProps = OwnProps & StateProps & DispatchProps;
export type SummaryState = OwnProps & StateProps & DispatchProps;

const mapStateToProps = (state: AppState, { tabId }: OwnProps): StateProps => {
  const isOpened = isProductSummaryOpened(state, tabId);
  const isDisabled = isPendingEnrichment(state, tabId) || isOpened;

  return { isDisabled };
};

const mapDispatchToProps = (dispatch: ThunkDispatch, { tabId }: OwnProps): DispatchProps => ({
  onShare() {
    dispatch(productSummaryRequested(tabId));
  },
});

export const connectShare = connect(mapStateToProps, mapDispatchToProps);
